import type { RequestConfig } from '@umijs/max';
import { message, notification } from 'antd';
import { outLogin, refresh } from '@/services/login/api';
import { history } from '@umijs/max';
import { Constants } from './util/constants';
import { getIntl } from '@umijs/max';
import { getErrorMsgId } from './util/utils';

// エラー表示種別
enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}

/**
 * 通信系の共通エラー処理
 */
export const errorConfig: RequestConfig = {
  
  // エラー処理（umi@3）
  errorConfig: {
    // エラーThrower
    errorThrower: (res: API.Response & { showType: ErrorShowType}) => {
      if (!res.success && res.errorCode) {
        const error: any = new Error(res.errorMessage);
        error.name = 'BusOneCustomError';
        error.info = res;
        // 独自エラーをスロー
        throw error;
      }
    },
    // エラーHandler
    errorHandler: (error: any, opts: any) => {
      /** 言語制御 */
      const intl = getIntl();

      if (opts?.skipErrorHandler) throw error;
      // エラーThrowerからのエラー
      if (error.name === 'BusOneCustomError') {
        const errorInfo: API.Response & { showType: ErrorShowType} | undefined = error.info;
        if (errorInfo) {
          const { errorMessage, errorCode } = errorInfo;
          switch (errorInfo.showType) {
            case ErrorShowType.SILENT:
              // do nothing
              break;
            case ErrorShowType.WARN_MESSAGE:
              message.warning(intl.formatMessage({ id: getErrorMsgId(errorCode) }));
              break;
            case ErrorShowType.ERROR_MESSAGE:
              message.error(intl.formatMessage({ id: getErrorMsgId(errorCode) }));
              break;
            case ErrorShowType.NOTIFICATION:
              notification.open({
                description: intl.formatMessage({ id: getErrorMsgId(errorCode) }),
                message: errorCode,
              });
              break;
            case ErrorShowType.REDIRECT:
              // TODO: redirect
              break;
            default:
              message.error(intl.formatMessage({ id: getErrorMsgId(errorCode) }));
          }
        }
      } else if (error.response) {
        // レスポンスが2xx以外の場合

        if (error.response.status === 403) {
          // 強制ログアウト
          message.error(intl.formatMessage({ id: getErrorMsgId(error.response.data.errorCode) }));
          outLogin();
          history.push(Constants.API.PATH.LOGIN);
        } else if (error.response.status === 401) {
          // 認証エラー
          if (error.response.data.errorMessage === Constants.API.AUTH.ERR.TOKEN_EXPIRED) {
            // トークンの有効期限切れの場合は、リフレッシュトークンでトークンを再取得
            refresh().then((rsp) => {
              // console.log('refresh return rsp = ' + JSON.stringify(rsp, null, 2));
              if (rsp.success) {
                // TODO 出来れば自動的に画面更新を再実行したいが、登録系の再実行懸念や発生頻度が低いことから、一旦実装しない
                // リフレッシュが成功したが、画面を更新できないためメッセージ表示
                message.error(intl.formatMessage({ id: 'request.auth.error.refresh' }));
              } else {
                console.log('refresh failed.');
                // リフレッシュが失敗したら、強制ログアウト
                outLogin();
                history.push(Constants.API.PATH.LOGIN);
              }
            });
          } else {
            if (error.response.data.errorMessage !== Constants.API.AUTH.ERR.NO_LOGIN) {
                // ログイン中でなければ、強制ログアウト
                outLogin();
                history.push(Constants.API.PATH.LOGIN);
            }
          }

        } else {
          // その他の場合
          // message.error(`Response status:${error.response.status}`);
          message.error(intl.formatMessage({ id: getErrorMsgId(error.response.data.errorCode) }));
        }

      } else if (error.request) {
        // レスポンスが受信できなかった場合
        message.error(intl.formatMessage({ id: 'request.comm.error.no.response' }));
      } else {
        // リクエストが送信できなかった場合
        message.error(intl.formatMessage({ id: 'request.comm.error.request.fail' }));
      }
    },
  },

  // リクエスト受信時の共通処理
  requestInterceptors: [
    (url: string, options: any) => {
      // ログ出力
      console.log('request url: ' + url);
      console.log('request method: ' + JSON.stringify(options.method, null, 2));
      console.log('request params: ' + JSON.stringify(options.params, null, 2));

      return {url, options};
    },
  ],

  // レスポンス送信時の共通処理
  responseInterceptors: [
    (response) => {
      // ログ出力
      console.log('response url: ' + JSON.stringify(response.config.url, null, 2));
      console.log('response method: ' + JSON.stringify(response.config.method, null, 2));
      console.log('response data: ' + JSON.stringify(response.data, null, 2));
      console.log('response params: ' + JSON.stringify(response.config.params, null, 2));

      // レスポンスをInterceptして、エラー処理を実施
      const { data } = response as unknown as API.Response;
      const intl = getIntl();
      if (data?.success === false && !data?.errorCode) {
        // エラー時の共通メッセージ
        // TODO　いらない？？？
        message.error(intl.formatMessage({ id: 'request.comm.error.fail' }));
      }

      return response;
    },
  ],
};
